module.exports = __webpack_public_path__ + "img/title-shiba.fde25872.png";